<template>
  <div class="nettdoc-basic-information">
    <SectionHeader text="Basic information of the patient" :dark="true" />
    <NumberInput
      label="Age"
      :showLabel="true"
      :model="store.patientInformation.age"
      v-on:action="value => store.addPatientInformation('age', value)"
    />

    <Dropdown
      label="Gender"
      :showLabel="true"
      :data="dropdownData"
      :choice="store.patientInformation.gender"
      v-on:action="value => store.addPatientInformation('gender', value)"
    />

    <SectionHeader text="Who is filling the anamnese sheets?" :dark="true" :required="true" />
    <div class="nettdoc-question__radiobuttons">
      <label class="nettdoc-question__radiobuttons--container">
        <p
          v-if="radioInfos[0].length > 0"
          class="nettdoc-question__radiobuttons--button-info"
        >{{ $t(radioInfos[0]) }}</p>
        <input name="radio" type="radio" value="the patient him-/herself" v-model="store.user" />
        <span class="nettdoc-radiotext">{{ $t("the patient him-/herself") }}</span>
        <span class="nettdoc-checkmark"></span>
      </label>

      <label class="nettdoc-question__radiobuttons--container">
        <input name="radio" type="radio" value="Relative or contact person" v-model="store.user" />
        <span class="nettdoc-radiotext">{{ $t("Relative or contact person") }}</span>
        <p
          v-if="radioInfos[1].length > 0"
          class="nettdoc-question__radiobuttons--button-info"
        >{{ $t(radioInfos[1]) }}</p>
        <span class="nettdoc-checkmark"></span>
      </label>
    </div>

    <Button
      text="Submit"
      :active="store.user && store.patientInformation.age !== null && store.patientInformation.age.length > 0 && store.patientInformation.gender !== null"
      v-on:action="submit"
    />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";
import Button from "../components/Button";
import NumberInput from "../components/NumberInput";
import Dropdown from "../components/Dropdown";
import SectionHeader from '../components/SectionHeader'
import detectingMobile from '../mixins/detectingMobile'
export default observer({
  name: "BasicInformation",
  data() {
    return {
      store: store,
      isDropdownActive: false,
      dropdownData: ["Male", "Female", "Other"],
      radioInfos: ["", "The questions only refer to the patient."]
    };
  },
  components: {
    Button,
    NumberInput,
    Dropdown,
    SectionHeader
  },
  created() {
    this.store.persistBasicInformation()
  },
  mixins:[detectingMobile],
  methods: {
    toggleDropdown: function() {
      this.isDropdownActive = !this.isDropdownActive;
    },
    submit: function() {
      let patientInformation = JSON.parse(localStorage.getItem('patientInformation'))
      if (patientInformation) {
        patientInformation.age = this.store.patientInformation.age
        patientInformation.gender = this.store.patientInformation.gender
      } else {
        patientInformation = {
          age: this.store.patientInformation.age,
          gender: this.store.patientInformation.gender
        };
      }
      const user = this.store.user;
      localStorage.setItem(
        "patientInformation",
        JSON.stringify(patientInformation)
      );
      localStorage.setItem("user", user);
      this.$router.push(`/${this.$i18n.locale}/nettdoctor/symptoms`);
    }
  }
});
</script>

<style lang="scss" scoped>
.nettdoc-basic-information {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
}
.nettdoc-question__radiobuttons {
  text-align: left;
  padding: 10px 16px;
  &--button-info {
    color: var(--dark-peach);
    font-size: 12px;
    font-weight: 600;
    margin-top: 4px;
    visibility: hidden;
  }
  &--container {
    display: block;
    box-sizing: border-box;
    height: 60px;
    position: relative;
    padding-left: 35px;
    padding-top: 22px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    color: var(--cool-grey);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      &:checked {
        ~ .nettdoc-checkmark {
          background: url(../assets/control-radio-check.svg);
        }
        ~ .nettdoc-radiotext {
          color: var(--charcoal-grey) !important;
        }
        ~ p {
          visibility: visible;
        }
      }
    }
    .nettdoc-checkmark {
      position: absolute;
      top: 18px;
      left: 0;
      height: 24px;
      width: 24px;
      background: url(../assets/control-radio-null.svg);
      border-radius: 50%;
    }
  }
}
</style>